import { useState, useEffect } from 'react';

export type StickyState =
  | 'static-header-full'
  | 'fixed-header-full'
  | 'header-collapsed'
  | 'header-partial-reveal';
// static-header-full: The initial view before scrolling at the top of the page - immeditely replaced
// fixed-header-full: As user scrolls down - but not as far as the scroll trigger position
// header-collapsed: As user scrolls down - beyond the scroll trigger position
// header-partial-reveal: As user begins to scroll upwards

export const isStickySearchHeaderStuck = (stickyState: StickyState): boolean =>
  stickyState !== 'static-header-full';

export const isStickySearchHeaderStuckAndNotFull = (stickyState: StickyState): boolean =>
  isStickySearchHeaderStuck(stickyState) && stickyState !== 'fixed-header-full';

const SCROLL_OFFSET_TRIGGER_POSITION: number = 90;
let scrollPreviousPosition: number = 0;
let previousStickyState: StickyState = 'static-header-full';

export const useStickySearchHeaderState = (): [StickyState, StickyState | undefined] => {
  const [stickyState, setStickyState] = useState<StickyState>('static-header-full');

  const updatePosition = () => {
    let newStickyState: StickyState;
    if (window.scrollY >= SCROLL_OFFSET_TRIGGER_POSITION) {
      if (window.scrollY >= scrollPreviousPosition) {
        newStickyState = 'header-collapsed';
      } else {
        newStickyState = 'header-partial-reveal';
      }
    } else {
      newStickyState = 'fixed-header-full';
    }

    if (newStickyState !== previousStickyState) {
      setStickyState(newStickyState);
    }
    scrollPreviousPosition = window.scrollY;
  };

  useEffect(() => {
    previousStickyState = stickyState;
  }, [stickyState]);

  useEffect(() => {
    scrollPreviousPosition = window.scrollY;
    window.addEventListener?.('scroll', updatePosition);
    updatePosition();
    return () => window.removeEventListener?.('scroll', updatePosition);
  }, []);

  return [stickyState, previousStickyState];
};
